/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WebSocketBroadcastResult { 
    status?: WebSocketBroadcastResult.StatusEnum;
    message?: string;
}
export namespace WebSocketBroadcastResult {
    export type StatusEnum = 'sent';
    export const StatusEnum = {
        SENT: 'sent' as StatusEnum
    };
}


